"use strict";

// typeof any so that it we don't have to cast when comparing a result to the error object
exports.errorObject = {
  e: {}
};